<div *ngIf="isShowing" class="popup-overlay">
    <div class="bg"></div>
    <div class="popup-container">
        <div class="popup" (click)="suppress($event)">
            <h1 class="title">Switch Role<i class="mdi mdi-close close" (click)="cancel()"></i></h1>
            <div class=" content pam">
                <form [formGroup]="roleForm" (ngSubmit)="submitRoleForm()">
                    <div class="row mtm">
                        <h3>Select Role</h3>
                    </div>
                    <div class="row mtm">
                            <div class="col-6">
                                <tcat-select formControlName="newRole" [placeholder]="'Role'" [values]="roleOptions"
                                    [config]="selectConfig">
                                </tcat-select>
                            </div>
                            <div class="col-12 ptm right pbl">
                                <button class="right mlm phl" (click)="cancel()" type="button">Close</button>
                                <button class="right mlm phl" (click)="reset()" type="button">Reset</button>
                                <button class="right mlm phl" type="submit">Submit</button>
                            </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>